import { CAR_TYPES } from '../constants';

import { PlannedRoutesVehicleSpecifications } from 'entities/map';

import { VEHICLE_TYPES } from '../constants';

export const getCarParametersForPlanningRoutes = (carType: string): PlannedRoutesVehicleSpecifications | null => ({
  [CAR_TYPES.heavyTruck]: {
    averageFuelConsumption: 30,
    numberOfAxles: 5,
    grossWeightKg: 40000,
    currentWeightKg: 38500,
    lengthCm: 1650,
    widthCm: 255,
    heightCm: 400,
    weightPerAxleKg: 10000,
    tiresCount: 10,
    trailerAxleCount: 2,
    trailerCount: 1,
    emissionType: 'euro6',
    co2EmissionClass: 1, // class1
    vehicleType: VEHICLE_TYPES.truck
  },
  [CAR_TYPES.lightTruck]: {
    averageFuelConsumption: 23,
    numberOfAxles: 2,
    grossWeightKg: 28000,
    currentWeightKg: 16000,
    lengthCm: 750,
    widthCm: 250,
    heightCm: 340,
    weightPerAxleKg: 10000,
    tiresCount: 4,
    emissionType: 'euro6',
    co2EmissionClass: 1, // class1
    vehicleType: VEHICLE_TYPES.truck
  },
  [CAR_TYPES.van]: {
    averageFuelConsumption: 11,
    numberOfAxles: 2,
    grossWeightKg: 3500,
    currentWeightKg: 3490,
    lengthCm: 600,
    widthCm: 200,
    heightCm: 255,
    weightPerAxleKg: 1800,
    tiresCount: 4,
    emissionType: 'euro6',
    co2EmissionClass: 1, // class1
    vehicleType: VEHICLE_TYPES.truck
  },
  [CAR_TYPES.bus]: {
    averageFuelConsumption: 28,
    numberOfAxles: 2,
    grossWeightKg: 18000,
    currentWeightKg: 16500,
    lengthCm: 1250,
    widthCm: 255,
    heightCm: 370,
    weightPerAxleKg: 9000,
    tiresCount: 6,
    trailerAxleCount: 0,
    trailerCount: 0,
    emissionType: 'euro6',
    co2EmissionClass: 1,
    vehicleType: VEHICLE_TYPES.bus
  }
}[carType] || null);
